import React from "react";

const AboutMe = () => {
  return (
    <div className="flex flex-col md:flex-row pb-6">
      <div className="w-full md:w-1/2 text-zinc-400 px-6 border-r-[1px] border-r-zinc-800 flex items-center">
        <div className="py-6">
          <h2 className="font-semibold mb-1">Hello! I'm Kalyan Gottimukkala</h2>
          <p className="text-base leading-6 ">
            a passionate and enthusiastic FULL (SQL, Express.js, React.js,
            Node.js) stack developer, ready to embark on an exciting journey in
            the world of web development. I bring a dynamic mix of skills and a
            hunger for continuous learning to create engaging and user-friendly
            web applications.
          </p>
        </div>
      </div>
      <div className="w-full md:w-1/2 p-6">
        <ul className="flex flex-col gap-1">
          <li className="aboutRightLi">
            <span className="aboutRightLiSpan">Age:</span>
            22
          </li>
          <li className="aboutRightLi">
            <span className="aboutRightLiSpan">Residence:</span>
            India
          </li>
          <li className="aboutRightLi">
            <span className="aboutRightLiSpan">Freelance:</span>
            Available
          </li>
          <li className="aboutRightLi">
            <span className="aboutRightLiSpan">Address:</span>
            Hyderabad
          </li>
        </ul>
      </div>
    </div>
  );
};

export default AboutMe;
